import React, { useEffect, useState } from "react";
import PageLoader from "../PageLoader/PageLoader";
import { hasSplash } from "../../utils/splash";
import { pagePending } from "../../utils/pendingPage";

/**
 * What a route shows while its page's chunk is on the way (utils/lazyPage.js).
 *
 * On the first load of a URL the boot splash is still covering the screen and
 * is held there until this unmounts (utils/pendingPage.js, SplashGate), so
 * there is nothing to draw. After the splash — a navigation inside the app —
 * the in-app loader, the same one a page shows while it fetches.
 */
export default function PageChunkFallback() {
  const [underSplash] = useState(() => hasSplash());
  useEffect(() => pagePending(), []);
  return underSplash ? null : <PageLoader />;
}
